import React, { useRef, useState } from "react"
import {
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Button,
  Input,
  Select,
  message,
  Modal,
  Space,
  Divider,
  notification,
} from "antd"
import {
  CarOutlined,
  SearchOutlined,
  ReadOutlined,
  TeamOutlined,
  FileTextOutlined,
  SafetyOutlined,
  CustomerServiceOutlined,
  RocketOutlined,
  UserOutlined,
  PhoneOutlined,
  StepForwardOutlined,
} from "@ant-design/icons"
import { FaMotorcycle, FaCar, FaShieldAlt } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import ROUTER from "src/router"
import "./style.css" // File CSS riêng cho animation
import MathCaptcha from "./components/MathCaptcha"

const { Title, Paragraph, Text } = Typography
const { Option } = Select

const HomePage = () => {
  const navigate = useNavigate()
  const [searchType, setSearchType] = useState("license_plate")
  const [searchValue, setSearchValue] = useState("")
  const [error, setError] = useState("")
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false)
  const [openVehicleModal, setOpenVehicleModal] = useState(false)
  const [isHovering, setIsHovering] = useState(null)
  const [isVerified, setIsVerified] = useState(false);


  const formatLicensePlate = plate => {
    const cleaned = plate.toUpperCase().replace(/[^A-Z0-9]/g, "")
    const match5 = cleaned.match(/^(\d{2}[A-Z]{1,2})(\d{3})(\d{2})$/) // 5 số
    const match4 = cleaned.match(/^(\d{2}[A-Z]{1,2})(\d{4})$/) // 4 số
    const match6 = cleaned.match(/^(\d{2}[A-Z]{1,2})(\d{1})(\d{3})(\d{2})$/) // kiểu 1 số phân loại

    if (match5) return `${match5[1]}-${match5[2]}.${match5[3]}`
    if (match4) return `${match4[1]}-${match4[2]}`
    if (match6) return `${match6[1]}${match6[2]}-${match6[3]}.${match6[4]}`
    return null
  }

  const BIEN_SO_PATTERN =
    /^[0-9]{2}[A-Z]{1,2}[0-9]{4,5}$|^[0-9]{2}[A-Z]{1,2}-[0-9]{3}\.[0-9]{2}$/

  const SDT_PATTERN = /^(0[0-9]{9})$/

  const validateInput = () => {
    const trimmed = searchValue.trim()
    if (!trimmed) {
      setError("Vui lòng nhập giá trị cần tìm kiếm.")
      return false
    }

    if (searchType === "license_plate") {
      const formatted = formatLicensePlate(trimmed)

      if (!formatted) {
        setError(
          "Biển số không hợp lệ. Ví dụ đúng: 30A12345, 43H222232, 43H2-222.32",
        )
        return false
      }
    } else if (searchType === "phone") {
      const normalizedValue = trimmed.replace(/[\s.-]/g, "")
      if (!SDT_PATTERN.test(normalizedValue)) {
        setError(
          "Số điện thoại không hợp lệ. Phải bắt đầu bằng số 0 và có 10 chữ số.",
        )
        return false
      }
    }

    setError("")
    return true
  }

  const handleSearch = () => {
    if (!searchType) {
      message.error("Vui lòng chọn loại tìm kiếm.")
      return
    }

    // if (!validateInput()) return

    // if (!isCaptchaVerified) {
    //   message.warning("Vui lòng xác thực Captcha trước khi tra cứu.")
    //   return
    // }
    if (!isVerified) {
      message.warning("Vui lòng xác thực trước khi tra cứu.")
      return
    }

    const trimmed = searchValue.trim().toUpperCase()
    const normalizedValue = trimmed.replace(/[\s.-]/g, "")
    const state = {
      type: searchType,
      keyword:
        searchType === "license_plate"
          ? formatLicensePlate(normalizedValue)
          : normalizedValue,
    }

    console.log("Navigating with state:", state)

    navigate(
      searchType === "license_plate"
        ? ROUTER.INSURANCE_CERTIFICATE
        : ROUTER.SEARCH_POLICY_PAGE_PHONE,
      { state },
    )
    setIsCaptchaVerified(false)
  }

  const FeatureCard = ({
    icon,
    title,
    description,
    gradient,
    onClick,
    index,
  }) => (
    <div
      className={`feature-card ${isHovering === index ? "hover" : ""}`}
      onClick={onClick}
      // onMouseEnter={() => {
      //   if (window.innerWidth > 768) {
      //     setIsHovering(index)
      //   }
      // }}
      // onMouseLeave={() => {
      //   if (window.innerWidth > 768) {
      //     setIsHovering(null)
      //   }
      // }}
      // onTouchStart={() => onClick?.()}
      style={{
        background: `linear-gradient(135deg, ${gradient.start}, ${gradient.end})`,
        borderRadius: "16px",
        padding: "24px",
        margin: "12px 0",
        cursor: "pointer",
        boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
        position: "relative",
        overflow: "hidden",
        border: "1px solid rgba(255,255,255,0.2)",
      }}
    >
      <div className="feature-card-bg"></div>
      <Row align="middle" gutter={16}>
        <Col span={6}>
          <div
            style={{
              background: "rgba(255,255,255,0.2)",
              borderRadius: "12px",
              padding: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(5px)",
              border: "1px solid rgba(255,255,255,0.3)",
            }}
          >
            {React.cloneElement(icon, {
              style: { fontSize: "24px", color: "white" },
            })}
          </div>
        </Col>
        <Col span={18}>
          <Title
            level={4}
            style={{ color: "white", margin: "0 0 8px 0", fontWeight: 600 }}
          >
            {title}
          </Title>
          <Paragraph
            style={{
              color: "rgba(255,255,255,0.8)",
              margin: 0,
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            {description}
          </Paragraph>
        </Col>
      </Row>
    </div>
  )

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #f8f9fa, #e9ecef)",
        padding: "24px 16px",
      }}
    >
      {/* Search Section */}
      <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "32px 24px",
          marginBottom: "32px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          border: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          {/* <div
            style={{
              background: "linear-gradient(135deg, #1890ff, #096dd9)",
              borderRadius: "50%",
              width: "80px",
              height: "80px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
              boxShadow: "0 8px 24px rgba(24, 144, 255, 0.3)",
              transition: "transform 0.3s ease",
              transform: isHovering === "search" ? "scale(1.1)" : "scale(1)",
            }}
            onMouseEnter={() => setIsHovering("search")}
            onMouseLeave={() => setIsHovering(null)}
          >
            <SearchOutlined style={{ fontSize: "32px", color: "white" }} />
          </div> */}
          <Title
            level={3}
            style={{ margin: 0, color: "#333", fontWeight: 600 }}
          >
            Tra cứu ấn chỉ bảo hiểm
          </Title>
          <Paragraph
            style={{ color: "#666", margin: "8px 0 0", fontSize: "16px" }}
          >
            Nhanh chóng - Chính xác - Bảo mật
          </Paragraph>
        </div>

        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                fontWeight: 600,
                color: "#333",
                marginBottom: "8px",
              }}
            >
              Tra cứu theo
            </label>
            <Select
              value={searchType}
              onChange={v => {
                setSearchType(v)
                setSearchValue("")
                setError("")
              }}
              size="large"
              style={{
                width: "100%",
                borderRadius: "12px",
              }}
              dropdownStyle={{ borderRadius: "12px" }}
            >
              <Option value="license_plate">
                <Space>
                  <CarOutlined />
                  Biển số xe
                </Space>
              </Option>
              <Option value="phone">
                <Space>
                  <PhoneOutlined />
                  Số điện thoại
                </Space>
              </Option>
            </Select>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                fontWeight: 600,
                color: "#333",
                marginBottom: "8px",
              }}
            >
              {searchType === "license_plate" ? "Biển số xe" : "Số điện thoại"}
            </label>
            <Input
              placeholder={
                searchType === "license_plate"
                  ? "Nhập biển số (VD: 30A12345)"
                  : "Nhập số điện thoại (VD: 0987654321)"
              }
              value={searchValue}
              onChange={e => {
                setSearchValue(e.target.value)
                if (error) setError("")
              }}
              size="large"
              status={error ? "error" : ""}
              style={{
                borderRadius: "12px",
                fontSize: "16px",
                padding: "12px 16px",
              }}
            />
            {error && (
              <div
                style={{
                  color: "#ff4d4f",
                  fontSize: "14px",
                  marginTop: "8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ marginRight: "4px" }}>⚠️</span>
                {error}
              </div>
            )}
          </div>
          <MathCaptcha onVerify={setIsVerified} />


          <Button
            type="primary"
            block
            size="large"
            disabled={!searchValue.trim() || !isVerified}
            onClick={handleSearch}
            style={{
              height: "56px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #1890ff, #096dd9)",
              border: "none",
              fontSize: "18px",
              fontWeight: 600,
              boxShadow: "0 4px 20px rgba(24, 144, 255, 0.3)",
              transition: "all 0.3s ease",
            }}
            icon={<SearchOutlined />}
          >
            Tra cứu ngay
          </Button>
        </div>
      </div>

      {/* Features Section */}
      <div style={{ marginBottom: "32px" }}>
        <Title
          level={4}
          style={{
            color: "#333",
            marginBottom: "16px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
          }}
        >
          <RocketOutlined style={{ marginRight: "8px", color: "#1890ff" }} />
          DỊCH VỤ NỔI BẬT
        </Title>

        <FeatureCard
          icon={<CarOutlined />}
          title="Mua bảo hiểm mới"
          description="Đăng ký bảo hiểm xe ô tô, xe máy hoàn toàn online với ưu đãi hấp dẫn"
          gradient={{ start: "#1890ff", end: "#096dd9" }}  // Xanh dương đậm → hành động chính, tin cậy
          onClick={() => setOpenVehicleModal(true)}
          index={0}
        />
        <FeatureCard
          icon={<TeamOutlined />}
          title="Đăng ký cộng tác viên"
          description="Cơ hội kiếm thêm thu nhập bằng việc giới thiệu khách hàng mua bảo hiểm"
          gradient={{ start: "#722ed1", end: "#531dab" }}  // Tím → đặc trưng cho đối tác, kiếm tiền
          onClick={() =>
            notification.info({
              message: "Đang triển khai",
              placement: "top",
            })
          }
          index={1}
        />
        <FeatureCard
          icon={<StepForwardOutlined />}  // hoặc <PlayCircleOutlined /> / <ShoppingOutlined /> nếu muốn
          title="Hướng dẫn mua hàng"
          description="Xem chi tiết 9 bước mua bảo hiểm trách nhiệm dân sự online nhanh chóng, dễ dàng và an toàn"
          gradient={{ start: "#1890ff", end: "#40a9ff" }}  // Xanh dương chính → nhạt hơn: tin cậy + nổi bật, dễ đọc chữ trắng
          onClick={() => navigate(ROUTER.INSURANCE_GUIDE)}  // hoặc set state mở modal/fullpage hướng dẫn
          index={2}  // Đặt đầu tiên để ưu tiên hiển thị
        />
        {/* <FeatureCard
          icon={<ReadOutlined />}
          title="Tin tức bảo hiểm"
          description="Cập nhật những thông tin mới nhất về chính sách, luật và ưu đãi"
          gradient={{ start: "#13c2c2", end: "#08979c" }}  // Teal/xanh ngọc → phù hợp nội dung thông tin, kiến thức
          onClick={() => navigate(ROUTER.NEWS_PAGE)}
          index={2}
        /> */}

        <FeatureCard
          icon={<ReadOutlined />}
          title="HD liên hệ tổn thất"
          description="Hướng dẫn xử lý sự cố và liên hệ tổng đài hỗ trợ 24/7"
          gradient={{ start: "#fa541c", end: "#d4380d" }}  // Cam đỏ → nổi bật, khẩn cấp, liên quan đến sự cố/tổn thất
          onClick={() => navigate(ROUTER.CLAIM_SUPPORT_PAGE)}
          index={3}
        />

        <FeatureCard
          icon={<FileTextOutlined />}
          title="Chính sách mua hàng"
          description="Xem chi tiết điều khoản, hoàn tiền và bảo mật khi mua bảo hiểm"
          gradient={{ start: "#fa8c16", end: "#d46b08" }}
          onClick={() => navigate(ROUTER.PURCHASE_POLICY)}
          index={4}
        />
      </div>

      {/* Why Choose Us */}
      {/* <div
        style={{
          background: "white",
          borderRadius: "16px",
          padding: "32px 24px",
          marginBottom: "32px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
          border: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <Title
          level={3}
          style={{
            color: "#333",
            textAlign: "center",
            marginBottom: "24px",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FaShieldAlt style={{ marginRight: "12px", color: "#1890ff" }} />
          TẠI SAO CHỌN CHÚNG TÔI?
        </Title>

        <Row gutter={[24, 24]} style={{ marginTop: "20px" }}>
          {[
            {
              icon: (
                <CustomerServiceOutlined
                  style={{ fontSize: "32px", color: "#1890ff" }}
                />
              ),
              title: "Hỗ trợ 24/7",
              description:
                "Đội ngũ chăm sóc khách hàng luôn sẵn sàng hỗ trợ bạn mọi lúc",
            },
            {
              icon: (
                <SafetyOutlined
                  style={{ fontSize: "32px", color: "#52c41a" }}
                />
              ),
              title: "Bảo mật tuyệt đối",
              description:
                "Cam kết bảo mật thông tin khách hàng với công nghệ mã hóa tiên tiến",
            },
            {
              icon: (
                <RocketOutlined
                  style={{ fontSize: "32px", color: "#faad14" }}
                />
              ),
              title: "Nhanh chóng",
              description:
                "Quy trình đơn giản, thời gian xử lý chỉ trong vài phút",
            },
            {
              icon: (
                <UserOutlined style={{ fontSize: "32px", color: "#722ed1" }} />
              ),
              title: "Thân thiện",
              description:
                "Giao diện trực quan, dễ sử dụng cho mọi đối tượng khách hàng",
            },
          ].map((item, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <div
                style={{
                  background: "white",
                  borderRadius: "12px",
                  padding: "24px",
                  height: "100%",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                  border: "1px solid rgba(0,0,0,0.05)",
                  textAlign: "center",
                  ":hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <div style={{ marginBottom: "16px" }}>{item.icon}</div>
                <Title level={5} style={{ marginBottom: "8px", color: "#333" }}>
                  {item.title}
                </Title>
                <Text type="secondary" style={{ fontSize: "14px" }}>
                  {item.description}
                </Text>
              </div>
            </Col>
          ))}
        </Row>
      </div> */}

      {/* Vehicle Selection Modal */}
      <Modal
        title={null}
        open={openVehicleModal}
        onCancel={() => setOpenVehicleModal(false)}
        footer={null}
        centered
        width={400}
        bodyStyle={{ padding: 0 }}
        closable={false}
        style={{ borderRadius: "16px" }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "16px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #1890ff, #096dd9)",
              padding: "24px",
              textAlign: "center",
              color: "white",
            }}
          >
            <Title
              level={3}
              style={{ color: "white", margin: 0, fontWeight: 600 }}
            >
              Chọn loại xe
            </Title>
            <Text style={{ color: "rgba(255,255,255,0.8)" }}>
              Bạn muốn mua bảo hiểm cho loại xe nào?
            </Text>
          </div>

          <div style={{ padding: "24px" }}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div
                  className="vehicle-card"
                  onClick={() => {
                    setOpenVehicleModal(false)
                    navigate(ROUTER.ORDER_SEAL, { state: { vehicle: "car" } })
                  }}
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    cursor: "pointer",
                    border: "1px solid #f0f0f0",
                    transition: "all 0.3s ease",
                    ":hover": {
                      borderColor: "#1890ff",
                      boxShadow: "0 4px 12px rgba(24, 144, 255, 0.2)",
                    },
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: "16px" }}>
                    <FaCar
                      style={{
                        fontSize: "48px",
                        color: "#1890ff",
                        marginBottom: "8px",
                      }}
                    />
                  </div>
                  <Title
                    level={5}
                    style={{ textAlign: "center", margin: 0, color: "#333" }}
                  >
                    Bảo hiểm ô tô
                  </Title>
                  <Text
                    type="secondary"
                    style={{
                      display: "block",
                      textAlign: "center",
                      marginTop: "8px",
                    }}
                  >
                    Bảo vệ toàn diện cho xe ô tô
                  </Text>
                </div>
              </Col>
              <Col span={24}>
                <div
                  className="vehicle-card"
                  onClick={() => {
                    setOpenVehicleModal(false)
                    navigate(ROUTER.ORDER_SEAL, {
                      state: { vehicle: "motorbike" },
                      // notification.warning({
                      //   message: "Đang sửa chữa!",
                      //   // description: "Đang sửa chữa chức năng này!",
                      //   duration: 2,
                    })
                  }}
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    cursor: "pointer",
                    border: "1px solid #f0f0f0",
                    transition: "all 0.3s ease",
                    ":hover": {
                      borderColor: "#1890ff",
                      boxShadow: "0 4px 12px rgba(24, 144, 255, 0.2)",
                    },
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: "16px" }}>
                    <FaMotorcycle
                      style={{
                        fontSize: "48px",
                        color: "#1890ff",
                        marginBottom: "8px",
                      }}
                    />
                  </div>
                  <Title
                    level={5}
                    style={{ textAlign: "center", margin: 0, color: "#333" }}
                  >
                    Bảo hiểm xe máy
                  </Title>
                  <Text
                    type="secondary"
                    style={{
                      display: "block",
                      textAlign: "center",
                      marginTop: "8px",
                    }}
                  >
                    Giải pháp bảo hiểm cho xe máy
                  </Text>
                </div>
              </Col>
            </Row>

            <Divider style={{ margin: "16px 0" }} />

            <Button
              block
              size="large"
              onClick={() => setOpenVehicleModal(false)}
              style={{
                borderRadius: "8px",
                height: "48px",
                fontWeight: 500,
              }}
            >
              Đóng
            </Button>
          </div>
        </div>
      </Modal >
    </div >
  )
}

export default HomePage
